import { AppBundle } from 'api/optimalprint-sdk.d';
import { ProductItemPreview } from 'components/Common';
import ProductCarousel from 'components/Common/ProductCarousel/ProductCarousel';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import getCurrentCategory from 'store/category/selector/getCurrentCategory';
import getOthersAlsoBoughtProducts from 'store/product/selector/getOthersAlsoBoughtProducts';
import getProductId from 'store/product/selector/getProductId';
import gtmOthersAlsoBoughtEvent from 'utils/gtm/gtmOthersAlsoBoughtEvent';
import gtmSendEvent from 'utils/gtm/gtmSendEvent';
import gtmRecommendationClickEvent from 'utils/gtm/gtmRecommendationClickEvent';
import { Theme } from 'store/landing/types';
import getCategoryId from 'store/category/selector/getCategoryId';
import styles from './OthersAlsoBought.module.scss';

export interface OthersAlsoBoughtProps {
  theme?: Theme;
}

const OthersAlsoBought: FC<OthersAlsoBoughtProps> = ({ theme = 'default' }) => {
  const products = useSelector(getOthersAlsoBoughtProducts);
  const currentCategory = useSelector(getCurrentCategory);
  const categoryName = (useSelector(getCurrentCategory) as any)?.name;
  const categoryId = useSelector(getCategoryId);
  const currentProductId = useSelector(getProductId);
  const { t } = useTranslation();

  if (!products || products.length === 0) {
    return null;
  }

  const handleTrackingEvent = (
    product: AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response.Family.IDesign,
  ) => {
    gtmSendEvent(gtmOthersAlsoBoughtEvent(currentProductId, currentCategory?.title || '', product));
    if (!categoryId) return;
    gtmSendEvent(gtmRecommendationClickEvent('Others Also Bought', categoryName, categoryId, product.categoryId));
  };

  return (
    <div className={styles.container}>
      <ProductCarousel progressBar theme={theme} title={t('txt_others_also_bought')}>
        {products.map((product, index) => (
          <ProductItemPreview
            key={`${product.productId} + ${index}`}
            showPrice
            usePriceFromProps
            categoryId={product.categoryId}
            finalPrice={product.finalPrice.value}
            finalPriceFormatted={product.finalPrice.formatted}
            initialPrice={product.initialPrice.value}
            initialPriceFormatted={product.initialPrice.formatted}
            productThumbnail={product.thumbnail}
            productName={product.designName || ''}
            productId={product.productId}
            productUrl={product.productPageUrl}
            theme={theme}
            onClick={() => handleTrackingEvent(product)}
          />
        ))}
      </ProductCarousel>
    </div>
  );
};

export default OthersAlsoBought;
